The type of event, i.e. `HirerRelationshipChanged`.
